var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftmob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00001 13.75C6.90147 13.7504 6.80383 13.7312 6.71282 13.6934C6.62181 13.6557 6.53926 13.6001 6.47001 13.53L0.470011 7.52997C0.329561 7.38934 0.250671 7.19872 0.250671 6.99997C0.250671 6.80122 0.329561 6.61059 0.470011 6.46997L6.47001 0.469968C6.61219 0.337488 6.80023 0.265365 6.99453 0.268794C7.18883 0.272222 7.37422 0.350934 7.51163 0.488347C7.64905 0.62576 7.72776 0.811145 7.73119 1.00545C7.73461 1.19975 7.66249 1.38779 7.53001 1.52997L2.06001 6.99997L7.53001 12.47C7.67046 12.6106 7.74935 12.8012 7.74935 13C7.74935 13.1987 7.67046 13.3893 7.53001 13.53C7.46077 13.6001 7.37822 13.6557 7.2872 13.6934C7.19619 13.7312 7.09855 13.7504 7.00001 13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 7.75H1C0.801088 7.75 0.610322 7.67098 0.46967 7.53033C0.329018 7.38968 0.25 7.19891 0.25 7C0.25 6.80109 0.329018 6.61032 0.46967 6.46967C0.610322 6.32902 0.801088 6.25 1 6.25H15C15.1989 6.25 15.3897 6.32902 15.5303 6.46967C15.671 6.61032 15.75 6.80109 15.75 7C15.75 7.19891 15.671 7.38968 15.5303 7.53033C15.3897 7.67098 15.1989 7.75 15 7.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftmob);
export default __webpack_public_path__ + "static/media/arrow-leftmob.2d224455ccdd5920dbbabb597e7e4eb8.svg";
export { ForwardRef as ReactComponent };